import { Tooltip } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT, fontSizing } from '~/src/dash/components/text/common';
import { Col, Cols, ISimpleOptionSelect, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const getColStyle = (idx: number, isLast?: boolean): CSS.Properties => {
  if (isLast) {
    return {
      borderRadius: '0 5px 5px 0',
      borderLeft: 'none',
    };
  }
  if (idx === 0) {
    return {
      borderRadius: '5px 0 0 5px',
    };
  } else {
    return {
      borderRadius: 'none',
      borderLeft: 'none',
    };
  }
};

interface ISingleSelectTogglesProps {
  isDisabled?: boolean;
  options: ISimpleOptionSelect[];
  onChange: (value: string) => void;
  size?: string;
  tooltipText?: string;
}

export const SingleSelectToggles = ({
  isDisabled = false,
  options,
  onChange,
}: ISingleSelectTogglesProps) => {
  const numOptions = options.length - 1;
  return (
    <Cols
      style={{
        alignItems: 'center',
        rowGap: spacing.extraSmall,
        flexWrap: 'nowrap',
      }}
    >
      {options.map((toggle, i) => {
        const isActive = toggle.isSelected;
        let color = isActive ? publicaColors.veryDarkGray : publicaColors.darkGray;
        let background = isActive ? publicaColors.lavender : 'inherit';
        const disabled = isDisabled || toggle.isDisabled;
        if (disabled) {
          color = publicaColors.gray;
          background = isActive ? publicaColors.lightGray : publicaColors.veryLightGray;
        }

        return (
          <Col key={toggle.key}>
            <Tooltip
              title={toggle.label || toggle.value}
              placement='top'
              enterDelay={500}
              enterNextDelay={500}
            >
              <button
                onClick={() => onChange(toggle.key)}
                style={{
                  display: 'inline-block',
                  borderWidth: 0,
                  lineHeight: 'inherit',
                  fontFamily: 'inherit',
                  fontStyle: 'inherit',
                  whiteSpace: 'nowrap',
                  margin: 0,
                  background,
                  color,
                  transition: 'background 0.2s ease-out',
                  minWidth: '40px',
                  textAlign: 'center',
                  fontSize: fontSizing.small,
                  fontWeight: isActive ? FONT_WEIGHT.bold : FONT_WEIGHT.base,
                  border: `1px solid ${publicaColors.lightGray}`,
                  padding: '4px 12px',
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  pointerEvents: disabled ? 'none' : 'all',
                  ...getColStyle(i, i === numOptions),
                }}
              >
                {toggle.label}
              </button>
            </Tooltip>
          </Col>
        );
      })}
    </Cols>
  );
};
